// If using a module system (e.g. via vue-cli), import Vue and VueRouter
// and then call `Vue.use(VueRouter)`.
import Vue from 'vue'

// Vue Router
// The official router for Vue.js.
// https://github.com/vuejs/vue-router
import VueRouter from 'vue-router'

// store
// import store from '@/store'

import Handler from '@/views/Handler/Handler.vue'
import Playground from '@/views/Playground/Playground'
import TermosDeUso from '@/views/TermosDeUsoView/TermosDeUso'

// Define some routes
// Each route should map to a component. The "component" can
// either be an actual component constructor created via
// `Vue.extend()`, or just a component options object.
// We'll talk about nested routes later.
const routes = [
  // Playground
  {
    path: '/termosDeUso',
    component: TermosDeUso
  },
  {
    path: '/playground',
    component: Playground,
    children: [
      {
        path: '*',
        name: 'funcionalidade',
        component: Handler,
        props: true
      }
    ]
  },
  // Pagina Inicial
  {
    path: '*',
    component: Handler,
    meta: {
      requiresAuth: true
    },
    props: true
  }
]

Vue.use(VueRouter)

// Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes // short for `routes: routes`
})

// Global Navigation Guards
// https://router.vuejs.org/guide/advanced/navigation-guards.html#global-guards
router.beforeEach(async (to, from, next) => {
  // if (process.env.NODE_ENV !== 'production') {
  if (
    from.path.indexOf('playground') !== -1 &&
      to.path.indexOf('playground') === -1 &&
      to.path !== '/'
  ) {
    return next({
      path: `/playground${to.path}`,
      query: to.query,
      params: to.params
    })
  }
  // }
  next()
})

export default router
